export default __webpack_public_path__ + "static/media/arrow.f8d56261.svg";